import styled, { css, keyframes } from "styled-components";
import { theme } from "../../../constants/StyledComponents";

const shrinkIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.6) translate(30%, 30%);
  }
  to {
    opacity: 1;
    transform: scale(1) translate(0, 0);
  }
`;

const shrinkOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1) translate(0, 0);
  }
  to {
    opacity: 0;
    transform: scale(0.6) translate(30%, 30%);
  }
`;
export const StyledMatrixDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: end;
  width: 100%;
  box-sizing: border-box;
  gap: 24px;
  padding: 24px;

  & .profiles-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow-y: auto;
    width: 100%;
    height: 100%;

    & .profiles-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
      gap: 16px;
    }
  }
`;

export const StyledDetailsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  & .search-container {
    width: 250px;
  }
`;

export const StyledMatrixDetailsContent = styled.div<{
  $visible?: boolean;
  $isAnimatingClose?: boolean;
}>`
  display: flex;
  flex-direction: row;
  visibility: ${(props) => (props.$visible ? "visible" : "hidden")};
  background-color: ${theme.colors.white};
  flex-grow: 1;
  animation: ${(props) =>
    props.$isAnimatingClose
      ? css`
          ${shrinkOut} 0.5s ease-out forwards
        `
      : props.$visible
        ? css`
            ${shrinkIn} 0.5s ease-out
          `
        : "none"};

  & .first-column {
    border-right: 1px solid ${theme.colors.purple_2};
    padding: 24px 24px 0 0;
    flex-shrink: 0;
    width: fit-content;
  }

  & .matrix-container {
    height: 216px;
  }
`;
